import React from "react";

const SearchField = ({ searchValue, setSearchValue }) => {
  const handleChange = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <div className="h-[50px] max-w-[300px] w-[300px] flex gap-[10px] items-center text-base font-medium border p-3 bg-white rounded-[10px]">
      <img className="w-6 h-6" src="/images/searchIcon.svg" alt="Search Icon" />
      <input
        className="w-full placeholder:text-[#E7E7E7] placeholder:text-base placeholder:font-medium focus:outline-none"
        type="search"
        placeholder="Search"
        value={searchValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchField;
